import React from 'react';
import { Container } from 'reactstrap';
import HpsView from './HpsView';

const MailInbox = () => {
  document.title = 'List HPS';
  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <HpsView />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default MailInbox;
